/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum RoleSubCategory {
    PeopleAndCompanies = "PeopleAndCompanies",
    Consent = "Consent",
    IdVerification = "IdVerification",
    PhoneVerification = "PhoneVerification",
    AmlScreening = "AmlScreening",
    FaceVerification = "FaceVerification",
    BusinessSearch = "BusinessSearch",
    TinVerification = "TinVerification",
    Staff = "Staff",
    Settings = "Settings",
    Invoices = "Invoices",
    PriceBands = "PriceBands",
    Onboarding = "Onboarding",
}

export enum RoleCategory {
    Customers = "Customers",
    Products = "Products",
    Management = "Management",
}

export enum RequestStatus {
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
    Failed = "Failed",
    Expired = "Expired",
    Cancelled = "Cancelled",
}

export enum CaptureMethod {
    FormDataCapture = "FormDataCapture",
    ImageUpload = "ImageUpload"
}

export enum ProductPurchaseOrderStatus {
    Pending = "Pending",
    Paid = "Paid",
    Cancelled = "Cancelled",
}

export enum ProductPurchaseOrderInvoiceStatus {
    Pending = "Pending",
    Paid = "Paid",
    Cancelled = "Cancelled",
}

export enum ProductPaymentMethod {
    BankDeposit = "BankDeposit",
    MobileMoney = "MobileMoney",
    Free = "Free",
    IoTecWallet = "IoTecWallet",
}

export enum ProductCategory {
    IdVerification = "IdVerification",
    LandVerification = "LandVerification",
    TinVerification = "TinVerification",
    PhoneVerification = "PhoneVerification",
    DataConsent = "DataConsent",
    AmlScreening = "AmlScreening",
    BusinessSearch = "BusinessSearch",
    PhoneNumberActivity = "PhoneNumberActivity",
    CustomerOnboarding = "CustomerOnboarding",
    FaceVerification = "FaceVerification",
    FaceMatch = "FaceMatch",
}

export enum PhoneNumberVerificationStatus {
    Pending = "Pending",
    Success = "Success",
    Failed = "Failed",
    NotFound = "NotFound",
    Barred = "Barred",
}

export enum OnboardingVerificationType {
    SmsOtp = "SmsOtp",
    EmailOtp = "EmailOtp",
    ApiCall = "ApiCall",
}

export enum OnboardingActivityStatus {
    Pending = "Pending",
    Completed = "Completed",
}

export enum OnboardingTemplateType {
    Person = "Person",
    Company = "Company",
}

export enum OnboardingActivityType {
    FormData = "FormData",
    Document = "Document",
    Ocr = "Ocr",
    FaceVerification = "FaceVerification",
}

export enum OnboardingActivityFieldType {
    Text = "Text",
    Number = "Number",
    LongText = "LongText",
    Phone = "Phone",
    Email = "Email",
    IpAddress = "IpAddress",
    Link = "Link",
    SingleSelect = "SingleSelect",
    MultiSelect = "MultiSelect",
}

export enum OnboardingActivityCaptureAction {
    Upload = "Upload",
    Capture = "Capture",
    Both = "Both",
}

export enum OnboardingActivity {
    CaptureNationalId = "CaptureNationalId",
    CaptureFace = "CaptureFace",
    CapturePhoneNumber = "CapturePhoneNumber",
    CaptureEmailAddress = "CaptureEmailAddress",
    CapturePhysicalAddress = "CapturePhysicalAddress",
    CaptureProofOfAddress = "CaptureProofOfAddress",
    CaptureMobileMoneyNumber = "CaptureMobileMoneyNumber",
    CaptureBankAccount = "CaptureBankAccount",
}

export enum IoTecPayCollectionStatus {
    Pending = "Pending",
    SentToVendor = "SentToVendor",
    Success = "Success",
    Failed = "Failed",
    AwaitingApproval = "AwaitingApproval",
}

export enum HttpVerb {
    Post = "Post",
}

export enum FaceVerificationStatus {
    Pending = "Pending",
    Verified = "Verified",
    Failed = "Failed",
}

export enum DataIdentifierCategory {
    NIN = "NIN",
    BRN = "BRN",
    TIN = "TIN",
    FCN = "FCN",
    Passport = "Passport",
    DrivingPermit = "DrivingPermit",
    NSSF = "NSSF",
    Other = "Other",
    Email = "Email",
    Phone = "Phone",
    EmployeeNumber = "EmployeeNumber",
    VillageCard = "VillageCard",
}

export enum CustomerUrlCategory {
    Website = "Website",
    Facebook = "Facebook",
    Linkedin = "Linkedin",
    Twitter = "Twitter",
    Other = "Other",
}

export enum CustomerSalutation {
    Mr = "Mr",
    Mrs = "Mrs",
    Ms = "Ms",
    Dr = "Dr",
    Prof = "Prof",
    Other = "Other",
}

export enum CustomerPhoneCategory {
    Mobile = "Mobile",
    Office = "Office",
    Home = "Home",
    Fax = "Fax",
    Other = "Other",
}

export enum CustomerIdentificationCategory {
    NIN = "NIN",
    BRN = "BRN",
    TIN = "TIN",
    FCN = "FCN",
    Passport = "Passport",
    DrivingPermit = "DrivingPermit",
    VillageCard = "VillageCard",
    NSSF = "NSSF",
    Other = "Other",
}

export enum CustomerGender {
    Female = "Female",
    Male = "Male",
}

export enum CustomerEmailCategory {
    Personal = "Personal",
    Work = "Work",
    Other = "Other",
}

export enum CustomerCivilStatus {
    Single = "Single",
    Married = "Married",
    Divorced = "Divorced",
    Other = "Other",
}

export enum CustomerCategory {
    Person = "Person",
    Company = "Company",
}

export enum CustomerAddressCategory {
    Home = "Home",
    Work = "Work",
    Other = "Other",
}

export enum ConsentStatus {
    Created = "Created",
    Sent = "Sent",
    Approved = "Approved",
    Rejected = "Rejected",
    Revoked = "Revoked",
    Failed = "Failed",
    Canceled = "Canceled",
    Expired = "Expired",
}

export enum ConsentFieldType {
    Text = "Text",
    Number = "Number",
    Date = "Date",
    Checkbox = "Checkbox",
    Select = "Select",
}

export enum ConsentChannel {
    Web = "Web",
    Ussd = "Ussd",
    MobileApp = "MobileApp",
    System = "System",
    Other = "Other",
}

export enum CompanyCustomerCategory {
    PrivateLimited = "PrivateLimited",
    PublicLimited = "PublicLimited",
    SoleProprietorship = "SoleProprietorship",
    Partnership = "Partnership",
    Other = "Other",
}

export enum BusinessSearchStatus {
    NotFound = "NotFound",
    Incorporated = "Incorporated",
    Dissolved = "Dissolved",
    Error = "Error",
    OutdatedData = "OutdatedData",
    InProgress = "InProgress",
    Failed = "Failed",
}

export enum BusinessSearchCategory {
    FullEntity = "FullEntity",
    BasicEntity = "BasicEntity",
}

export enum BulkVerificationStatus {
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
    Error = "Error",
}

export enum AuthMode {
    Jwt = "Jwt",
    ApiKey = "ApiKey",
}

export enum AmlScreeningStatus {
    NoHits = "NoHits",
    HasHits = "HasHits",
    Failed = "Failed",
}

export interface Address {
    country?: string | null;
    district?: string | null;
    parish?: string | null;
    plot?: string | null;
    postalAddress?: string | null;
    region?: string | null;
    street?: string | null;
    subCountry?: string | null;
    village?: string | null;
}

export interface AmlScreeningCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    category: CustomerCategory;
    /**
     * string that is checked against sanctions list
     * @minLength 1
     */
    names: string;
    gender?: CustomerGender;
    /**
     * Include DateOfBirth in the screening for CustomerCategory.Person
     * @format date
     */
    dateOfBirth?: string | null;
    /**
     * This parameter defines if spelling differences need to be considered for the search string.
     *
     * 1: Fuzzy search with distance 1 (e.g. Angela will also match for Angelo) for the "names" parameter.
     *
     * 2: Fuzzy search with distance 2 (e.g. Angela will also match for Angale) for the "names" parameter.
     * @format int32
     */
    fuzzySearch?: number | null;
}

export interface AmlScreeningCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: AmlScreeningCreateModel[] | null;
}

export interface AmlScreeningViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    names?: string | null;
    /** @format int32 */
    fuzzySearch?: number | null;
    /** @format date */
    dateOfBirth?: string | null;
    gender?: CustomerGender;
    includes?: string[] | null;
    verificationStatus?: AmlScreeningStatus;
    /** @format int32 */
    totalHits?: number | null;
    /** @format date-time */
    timestamp?: string | null;
    category?: CustomerCategory;
    individualRecords?: IndividualFoundRecord[] | null;
    entityRecords?: EntityFoundRecord[] | null;
}

export interface AmlScreeningViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: AmlScreeningViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ApiKeyResetResponse {
    key?: string | null;
}

export interface ApiKeyViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    ownerName?: string | null;
    /** @format uuid */
    partnerId?: string;
    isActive?: boolean;
    role?: string | null;
    /** @format date-time */
    lastUsedAt?: string | null;
}

export interface BaseApproveModel {
    /** @format uuid */
    id?: string;
    /** @minLength 1 */
    remarks: string;
    decision?: boolean;
}

export interface BaseResponse {
    message?: string | null;
    status?: boolean;
    data?: Record<string, any>;
}

export interface BulkAmlScreeningCreateModel {
    category: CustomerCategory;
    /** @minItems 1 */
    selectedCustomerIds: string[];
    /** The reference id that will be used to identify the request */
    referenceId?: string | null;
    /** Set to true if you include the gender in the screening */
    includeGender?: boolean | null;
    /** Set to true if you include the date of birth in the screening */
    includeDateOfBirth?: boolean | null;
}

export interface BulkAmlScreeningImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkBusinessSearchCreateModel {
    /** @minItems 1 */
    selectedCustomerIds: string[];
    /** The reference id that will be used to identify the request */
    referenceId?: string | null;
}

export interface BulkBusinessSearchImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkConsentRequestCreateModel {
    selectedCustomerIds?: string[] | null;
    /**
     * The template that is used to generate the document.
     * @format uuid
     */
    templateId?: string;
    /** The reference id that will be used to identify the consent request */
    referenceId?: string | null;
    /** Set to true if you want to send a consent request via email */
    includeEmail?: boolean;
}

export interface BulkConsentRequestEditModel {
    /** @format uuid */
    id?: string;
}

export interface BulkConsentRequestImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
    /** @format uuid */
    templateId?: string;
}

export interface BulkCustomerImportViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    status?: BulkVerificationStatus;
    /** @format int32 */
    totalRequests?: number;
    /** @format int32 */
    completedRequests?: number;
    /** @format int32 */
    failedRequests?: number;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    completedAt?: string | null;
    externalReference?: string | null;
    /** @format uuid */
    documentId?: string | null;
    document?: Doc;
    message?: string | null;
}

export interface BulkCustomerImportViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: BulkCustomerImportViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface BulkFaceVerificationImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkOnboardingImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
    /** @format uuid */
    templateId: string;
}

export interface BulkOnboardingWorkflowViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    status?: BulkVerificationStatus;
    /** @format int32 */
    totalRequests?: number;
    /** @format int32 */
    completedRequests?: number;
    /** @format int32 */
    failedRequests?: number;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    completedAt?: string | null;
    externalReference?: string | null;
    /** @format uuid */
    documentId?: string | null;
    document?: Doc;
    message?: string | null;
    /** @format uuid */
    templateId?: string | null;
}

export interface BulkOnboardingWorkflowViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: BulkOnboardingWorkflowViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface BulkPhoneNumberVerificationImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkVerificationImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkVerifyPersonInformationImportRequest {
    /**
     * The document to be used
     * @format uuid
     */
    docId?: string;
    externalReference?: string | null;
    message?: string | null;
    performAmlVerification?: boolean;
    performPhoneNumberVerification?: boolean;
    performIdVerification?: boolean;
    performBusinessVerification?: boolean;
    isAsync?: boolean;
    doProductVerification?: boolean;
}

export interface BulkVerifyPersonInformationPreview {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: VerifyPersonInformationRequestModel[] | null;
}

export interface BulkVerifyPersonInformationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    status?: BulkVerificationStatus;
    /** @format int32 */
    totalRequests?: number;
    /** @format int32 */
    completedRequests?: number;
    /** @format int32 */
    failedRequests?: number;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    completedAt?: string | null;
    externalReference?: string | null;
    /** @format uuid */
    documentId?: string | null;
    document?: Doc;
    message?: string | null;
}

export interface BulkVerifyPersonInformationViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: BulkVerifyPersonInformationViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface BusinessSearchCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    category?: BusinessSearchCategory;
    companyCategory?: CompanyCustomerCategory;
    /**
     * string that is checked against sanctions list
     * @minLength 1
     */
    businessRegistrationNumber: string;
}

export interface BusinessSearchCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: BusinessSearchCreateModel[] | null;
}

export interface BusinessSearchViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    category?: BusinessSearchCategory;
    businessRegistrationNumber?: string | null;
    subType?: string | null;
    registrationStatus?: string | null;
    entityName?: string | null;
    dissolutionDate?: string | null;
    incorporationDate?: string | null;
    registrationDate?: string | null;
    transactionReference?: string | null;
    searchStatus?: BusinessSearchStatus;
    responseData?: UrsbEntityFullResponseData;
}

export interface BusinessSearchViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: BusinessSearchViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ComboModel {
    id?: string | null;
    name?: string | null;
}

export interface CompanyCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    category?: BusinessSearchCategory;
    companyCategory?: CompanyCustomerCategory;
    /**
     * string that is checked against sanctions list
     * @minLength 1
     */
    businessRegistrationNumber: string;
}

export interface CompanyCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: CompanyCreateModel[] | null;
}

export interface CompanyCustomerCreateModel {
    /** @format uuid */
    id?: string | null;
    category?: CompanyCustomerCategory;
    /** @minLength 1 */
    name: string;
    email?: string | null;
    phone?: string | null;
    contactPersonPhone?: string | null;
    contactPersonEmail?: string | null;
    contactPersonName?: string | null;
    /** @minLength 1 */
    registrationNumber: string;
    /** @format date */
    registrationDate?: string | null;
    tinNumber?: string | null;
    /** @format uuid */
    customerPersonId?: string | null;
    /** @format uuid */
    accountManagerId?: string | null;
    /** @format uuid */
    bulkId?: string | null;
}

export interface CompanyCustomerViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: CompanyCustomerCategory;
    name?: string | null;
    registrationNumber?: string | null;
    /** @format date */
    registrationDate?: string | null;
    /** @format int32 */
    numberOfEmployees?: number | null;
    /** @format uuid */
    customerId?: string;
    contactPersonName?: string | null;
    contactPersonPhone?: string | null;
    contactPersonEmail?: string | null;
}

export interface CompanyInfo {
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}

export interface ConsentDataCustodianCreateModel {
    /** @minLength 1 */
    name: string;
    /** @minLength 1 */
    email: string;
    isPublic?: boolean;
    description?: string | null;
    dataIdentificationCategories?: DataIdentifierCategory[] | null;
    dataPoints?: string[] | null;
    dataPointsCsv?: string | null;
}

export interface ConsentDataCustodianEditModel {
    /** @format uuid */
    id?: string;
    /** @minLength 1 */
    name: string;
    /** @minLength 1 */
    email: string;
    isPublic?: boolean;
    description?: string | null;
    dataIdentificationCategories?: DataIdentifierCategory[] | null;
    dataPoints?: string[] | null;
    dataPointsCsv?: string | null;
}

export interface ConsentDataCustodianViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    name?: string | null;
    email?: string | null;
    isPublic?: boolean;
    description?: string | null;
    dataIdentificationCategories?: DataIdentifierCategory[] | null;
    dataPoints?: string[] | null;
}

export interface ConsentField {
    /** @format uuid */
    id?: string;
    name: string | null;
    label: string | null;
    type: ConsentFieldType;
    optionsCsv?: string | null;
    required?: boolean;
    columnWidth?: string | null;
}

export interface ConsentFingerPrintMatchStatus {
    transactionReference?: string | null;
    transactionStatus?: string | null;
    consentId?: string | null;
    message?: string | null;
    encodedData?: string | null;
}

export interface ConsentProcessApproveModel {
    /** @format uuid */
    requestId?: string;
    referenceId?: string | null;
    memo?: string | null;
    channel?: ConsentChannel;
    metaData?: Record<string, string>;
}

export interface ConsentRequestComboModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /**
     * The id of the partner requesting the consent.
     * @format uuid
     */
    partnerId?: string;
    partner?: XContactModel;
    /** A unique reference id from the external system. */
    referenceId?: string | null;
    /** A representation of the customer in the external system. */
    consentId?: string | null;
    dataIdentifier?: string | null;
    fullName?: string | null;
    ussdRequestMessage?: string | null;
    ussdApprovalMessage?: string | null;
    ussdRejectionMessage?: string | null;
    metaData?: Record<string, string>;
    requiresOtp?: boolean;
}

export interface ConsentRequestCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    metaData?: Record<string, string>;
    /**
     * The template that is being used to request for consent.
     * @format uuid
     */
    templateId?: string;
    /**
     * @format tel
     * @minLength 1
     */
    phoneNumber: string;
    /** @format email */
    email?: string | null;
    /**
     * Identifier for the entity who owns the data.
     * @minLength 1
     * @maxLength 150
     */
    dataIdentifier: string;
}

export interface ConsentRequestCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: ConsentRequestCreateModel[] | null;
}

export interface ConsentRequestLogViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    requestId?: string;
    status?: ConsentStatus;
    consentChannel?: ConsentChannel;
    /** @maxLength 50 */
    memo?: string | null;
    /** @maxLength 200 */
    details?: string | null;
    /** @maxLength 50 */
    userId?: string | null;
}

export interface ConsentRequestViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    consentStatus?: ConsentStatus;
    /**
     * The time when the consent sms was sent to the customer.
     * @format date-time
     */
    smsSentAt?: string | null;
    /**
     * The time when the consent email was sent to the customer.
     * @format date-time
     */
    emailSentAt?: string | null;
    /**
     * Time when the person responded to the request.
     * @format date-time
     */
    respondedOn?: string | null;
    /**
     * The person or system responding to the request.
     * @maxLength 50
     */
    responseBy?: string | null;
    /**
     * This is the reference id from the external system.
     * This could be the sessionID, transactionID, etc.
     * @maxLength 50
     */
    responseReferenceId?: string | null;
    /** @maxLength 100 */
    responseMemo?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    verifiedFullname?: string | null;
    /**
     * What data points are being consented to.
     * * NIN- Biodata, Fingerprint, photo
     * * Tin - Biodata, photo,tax clearance,employer
     * * Farmer - Biodata, photo, farm location, farm size, farm produce
     * @maxLength 50
     */
    dataPoints?: string | null;
    /** @maxLength 500 */
    detailedDataPoints?: string | null;
    /**
     * Identifier for the entity who owns the data.
     * @maxLength 150
     */
    dataIdentifier?: string | null;
    metaData?: Record<string, string>;
    /**
     * The entity that is holding the data.
     * @format uuid
     */
    dataHolderId?: string;
    consentId?: string | null;
    /**
     * The template that is being used to request for consent.
     * @format uuid
     */
    templateId?: string | null;
    template?: ComboModel;
}

export interface ConsentRequestViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: ConsentRequestViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ConsentTemplateComboModel {
    id?: string | null;
    name?: string | null;
    /** @format uuid */
    dataCustodianId?: string;
    dataCustodian?: ComboModel;
    fields?: ConsentField[] | null;
}

export interface ConsentTemplateCreateModel {
    /** @format uuid */
    dataCustodianId?: string;
    /**
     * @minLength 1
     * @maxLength 40
     */
    name: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    requestMessage: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    approvalMessage: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    rejectionMessage: string;
    /** @maxLength 1600 */
    detailedRequestMessage?: string | null;
    /** @maxLength 1600 */
    detailedApprovalMessage?: string | null;
    /** @maxLength 1600 */
    detailedRejectionMessage?: string | null;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdRequestMessage: string;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdApprovalMessage: string;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdRejectionMessage: string;
    dataPoints?: string | null;
    /** @format uuid */
    pdfTemplateId?: string | null;
    requiresOtp?: boolean;
    preFetchDataFromCustodian?: boolean;
    postFetchDataFromCustodian?: boolean;
    skipPhoneVerification?: boolean;
    skipRequestSentNotification?: boolean;
    skipRequestCompleteNotification?: boolean;
    /** @format int32 */
    expiryInMinutes?: number;
    fields?: ConsentField[] | null;
    consentChannels?: ConsentChannel[] | null;
}

export interface ConsentTemplateEditModel {
    /** @format uuid */
    id?: string;
    /** @format uuid */
    dataCustodianId?: string;
    /**
     * @minLength 1
     * @maxLength 100
     */
    name: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    requestMessage: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    approvalMessage: string;
    /**
     * @minLength 1
     * @maxLength 800
     */
    rejectionMessage: string;
    /** @maxLength 1600 */
    detailedRequestMessage?: string | null;
    /** @maxLength 1600 */
    detailedApprovalMessage?: string | null;
    /** @maxLength 1600 */
    detailedRejectionMessage?: string | null;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdRequestMessage: string;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdApprovalMessage: string;
    /**
     * @minLength 1
     * @maxLength 200
     */
    ussdRejectionMessage: string;
    dataPoints?: string | null;
    /** @format uuid */
    pdfTemplateId?: string | null;
    requiresOtp?: boolean;
    preFetchDataFromCustodian?: boolean;
    postFetchDataFromCustodian?: boolean;
    skipPhoneVerification?: boolean;
    skipRequestSentNotification?: boolean;
    skipRequestCompleteNotification?: boolean;
    /** @format int32 */
    expiryInMinutes?: number;
    fields?: ConsentField[] | null;
    consentChannels?: ConsentChannel[] | null;
}

export interface ConsentTemplateViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    dataIdentifierCategory?: DataIdentifierCategory;
    /** @format uuid */
    dataCustodianId?: string;
    dataCustodian?: ConsentDataCustodianViewModel;
    name?: string | null;
    requestMessage?: string | null;
    approvalMessage?: string | null;
    rejectionMessage?: string | null;
    detailedRequestMessage?: string | null;
    detailedApprovalMessage?: string | null;
    detailedRejectionMessage?: string | null;
    ussdRequestMessage?: string | null;
    ussdApprovalMessage?: string | null;
    ussdRejectionMessage?: string | null;
    dataPoints?: string | null;
    requiresOtp?: boolean;
    preFetchDataFromCustodian?: boolean;
    postFetchDataFromCustodian?: boolean;
    skipPhoneVerification?: boolean;
    skipRequestSentNotification?: boolean;
    skipRequestCompleteNotification?: boolean;
    /** @format int32 */
    expiryInMinutes?: number;
    fields?: ConsentField[] | null;
    consentChannels?: ConsentChannel[] | null;
    /** @format uuid */
    pdfTemplateId?: string | null;
    pdfTemplate?: DocViewModel;
}

export interface ContactMiniViewModel {
    /** @format uuid */
    id?: string;
    /** @format uuid */
    contactPersonId?: string | null;
    name: string | null;
    email?: string | null;
    phone?: string | null;
}

export interface Corporate {
    businessRegistrationNumber?: string | null;
    companyType?: string | null;
    dateOfIncorporation?: string | null;
    entityName?: string | null;
    officialEmail?: string | null;
    officialTelephoneNumber?: string | null;
}

export interface CustomerAddressCreateModel {
    category?: CustomerAddressCategory;
    /** @format uuid */
    customerId?: string;
    country?: string | null;
    district?: string | null;
    county?: string | null;
    subCounty?: string | null;
    village?: string | null;
    parish?: string | null;
    postalCode?: string | null;
    street?: string | null;
    freeForm?: string | null;
    placeId?: string | null;
    latLon?: string | null;
    /** @format date-time */
    startDate?: string | null;
    /** @format date-time */
    endDate?: string | null;
    isPrimary?: boolean;
}

export interface CustomerAddressEditModel {
    category?: CustomerAddressCategory;
    /** @format uuid */
    customerId?: string;
    country?: string | null;
    district?: string | null;
    county?: string | null;
    subCounty?: string | null;
    village?: string | null;
    parish?: string | null;
    postalCode?: string | null;
    street?: string | null;
    freeForm?: string | null;
    placeId?: string | null;
    latLon?: string | null;
    /** @format date-time */
    startDate?: string | null;
    /** @format date-time */
    endDate?: string | null;
    isPrimary?: boolean;
    /** @format uuid */
    id?: string;
}

export interface CustomerAddressViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: CustomerAddressCategory;
    /** @format uuid */
    customerId?: string;
    country?: string | null;
    district?: string | null;
    county?: string | null;
    subCounty?: string | null;
    village?: string | null;
    parish?: string | null;
    postalCode?: string | null;
    street?: string | null;
    freeForm?: string | null;
    placeId?: string | null;
    latLon?: string | null;
    /** @format date-time */
    startDate?: string | null;
    /** @format date-time */
    endDate?: string | null;
    isPrimary?: boolean;
}

/** Model to create a consent request by an existing customer */
export interface CustomerConsentRequestCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    metaData?: Record<string, string>;
    /**
     * The template that is being used to request for consent.
     * @format uuid
     */
    templateId?: string;
    /**
     * The customer who will give consent
     * @format uuid
     */
    customerId?: string;
}

export interface CustomerEmailCreateModel {
    category?: CustomerEmailCategory;
    /** @format uuid */
    customerId?: string;
    value?: string | null;
    isPrimary?: boolean;
}

export interface CustomerEmailEditModel {
    category?: CustomerEmailCategory;
    /** @format uuid */
    customerId?: string;
    value?: string | null;
    isPrimary?: boolean;
    /** @format uuid */
    id?: string;
}

export interface CustomerEmailViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: CustomerEmailCategory;
    /** @format uuid */
    customerId?: string;
    value?: string | null;
    isPrimary?: boolean;
}

export interface CustomerIdentificationCreateModel {
    category?: CustomerIdentificationCategory;
    /** @format uuid */
    customerId?: string;
    documentId?: string | null;
    value?: string | null;
    issuingCountry?: string | null;
    /** @format date-time */
    issueDate?: string | null;
    /** @format date-time */
    expiryDate?: string | null;
    isPrimary?: boolean;
}

export interface CustomerIdentificationEditModel {
    category?: CustomerIdentificationCategory;
    /** @format uuid */
    customerId?: string;
    documentId?: string | null;
    value?: string | null;
    issuingCountry?: string | null;
    /** @format date-time */
    issueDate?: string | null;
    /** @format date-time */
    expiryDate?: string | null;
    isPrimary?: boolean;
    /** @format uuid */
    id?: string;
}

export interface CustomerIdentificationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: CustomerIdentificationCategory;
    /** @format uuid */
    customerId?: string;
    documentId?: string | null;
    value?: string | null;
    issuingCountry?: string | null;
    /** @format date-time */
    issueDate?: string | null;
    /** @format date-time */
    expiryDate?: string | null;
    isPrimary?: boolean;
}

export interface CustomerMiniViewModel {
    /** @format uuid */
    id?: string;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}

export interface CustomerMiniViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: CustomerMiniViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface CustomerPhoneCreateModel {
    /** @format uuid */
    customerId?: string;
    category?: CustomerPhoneCategory;
    value?: string | null;
    isPrimary?: boolean;
}

export interface CustomerPhoneEditModel {
    /** @format uuid */
    customerId?: string;
    category?: CustomerPhoneCategory;
    value?: string | null;
    isPrimary?: boolean;
    /** @format uuid */
    id?: string;
}

export interface CustomerPhoneViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    customerId?: string;
    category?: CustomerPhoneCategory;
    value?: string | null;
    isPrimary?: boolean;
}

export interface CustomerTagCreateModel {
    /** @format uuid */
    customerId?: string;
    value?: string | null;
}

export interface CustomerTagEditModel {
    /** @format uuid */
    customerId?: string;
    value?: string | null;
    /** @format uuid */
    id?: string;
}

export interface CustomerTagViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    customerId?: string;
    value?: string | null;
}

export interface CustomerUrlCreateModel {
    /** @format uuid */
    customerId?: string;
    category?: CustomerUrlCategory;
    value?: string | null;
}

export interface CustomerUrlEditModel {
    /** @format uuid */
    customerId?: string;
    category?: CustomerUrlCategory;
    value?: string | null;
    /** @format uuid */
    id?: string;
}

export interface CustomerUrlViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    customerId?: string;
    category?: CustomerUrlCategory;
    value?: string | null;
}

export interface CustomerViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: CustomerCategory;
    person?: PersonCustomerViewModel;
    company?: CompanyCustomerViewModel;
    /** @format uuid */
    partnerId?: string;
    /** @format uuid */
    bulkId?: string | null;
    partner?: CustomerMiniViewModel;
    createdByData?: CustomerMiniViewModel;
    identifications?: CustomerIdentificationViewModel[] | null;
    phones?: CustomerPhoneViewModel[] | null;
    emails?: CustomerEmailViewModel[] | null;
    addresses?: CustomerAddressViewModel[] | null;
    urls?: CustomerUrlViewModel[] | null;
    tags?: CustomerTagViewModel[] | null;
}

export interface CustomerViewModelCreateResponse {
    /**
     * Indicates whether the record was newly created.
     * True = record was created; False = duplicates exist instead.
     */
    isCreated?: boolean;
    createdRecord?: CustomerViewModel;
    /**
     * List of existing records that matched the creation criteria.
     * Null or empty if a new record was created.
     */
    duplicates?: CustomerViewModel[] | null;
}

export interface CustomerViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: CustomerViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface DilisenseSource {
    sourceId?: string | null;
    name?: string | null;
    description?: string | null;
    /** @format uri */
    link?: string | null;
    countryName?: string | null;
}

export interface Director {
    corporate?: Corporate;
    individual?: Individual;
    type?: string | null;
}

export interface Doc {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    lastUpdated?: string | null;
    isDeleted?: boolean;
    name?: string | null;
    contentType?: string | null;
    originalName?: string | null;
    description?: string | null;
    size?: string | null;
    /** @format uuid */
    referenceId?: string | null;
    /** @format uuid */
    partnerId?: string;
}

export interface DocViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    name?: string | null;
    contentType?: string | null;
    originalName?: string | null;
    description?: string | null;
    size?: string | null;
    /** @format uuid */
    partnerId?: string;
}

export interface EditModel {
    /** @format uuid */
    id?: string;
}

export interface EntityFoundRecord {
    sourceType?: string | null;
    entityType?: string | null;
    sourceId?: string | null;
    name?: string | null;
    aliasNames?: string[] | null;
    address?: string[] | null;
    sanctionDetails?: string[] | null;
    listDate?: string | null;
    source?: DilisenseSource;
}

export interface FaceVerNationalId {
    /** @maxLength 100 */
    firstName?: string | null;
    /** @maxLength 100 */
    lastName?: string | null;
    /** @maxLength 50 */
    nin?: string | null;
    /** @maxLength 50 */
    cardNumber?: string | null;
    /** @maxLength 50 */
    dateOfBirth?: string | null;
    /** @maxLength 50 */
    dateOfExpiration?: string | null;
    /** @maxLength 50 */
    gender?: string | null;
    /** @maxLength 50 */
    nationality?: string | null;
}

export interface FaceVerificationCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    narration: string | null;
}

export interface FaceVerificationCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: FaceVerificationCreateModel[] | null;
}

export interface FaceVerificationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /**
     * Request name
     * @example "John Doe"
     */
    requestName?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    reference?: string | null;
    narration?: string | null;
    verificationId?: string | null;
    verificationUrl?: string | null;
    faceVerificationStatus?: FaceVerificationStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    rawResponseData?: string | null;
    nationalIdData?: FaceVerNationalId;
    profileImageUrl?: string | null;
    nationalIdImageUrl?: string | null;
    niraMatchingStatus?: string | null;
    niraCardStatus?: string | null;
    niraTransactionStatus?: string | null;
    niraErrorCode?: string | null;
    niraErrorMessage?: string | null;
    niraTransactionDate?: string | null;
}

export interface FaceVerificationViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: FaceVerificationViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ImportError {
    /** @format int32 */
    row?: number;
    /** @format int32 */
    col?: number;
    error?: string | null;
}

export interface Individual {
    givenName?: string | null;
    idNumber?: string | null;
    idType?: string | null;
    middleName?: string | null;
    surname?: string | null;
}

export interface IndividualFoundRecord {
    entityType?: string | null;
    name?: string | null;
    sourceId?: string | null;
    aliasNames?: string[] | null;
    dateOfBirth?: string[] | null;
    citizenship?: string[] | null;
    occupations?: string[] | null;
    politicalParties?: string[] | null;
    sourceType?: string | null;
    pepType?: string | null;
    listDate?: string | null;
    gender?: string | null;
    description?: string[] | null;
    givenNames?: string[] | null;
    placeOfBirth?: string[] | null;
    spouse?: string[] | null;
    siblings?: string[] | null;
    parents?: string[] | null;
    lastNames?: string[] | null;
    aliasGivenNames?: string[] | null;
    citizenshipRemarks?: string[] | null;
    sanctionDetails?: string[] | null;
    otherInformation?: string[] | null;
    links?: string[] | null;
    address?: string[] | null;
    titles?: string[] | null;
    source?: DilisenseSource;
}

export interface IoTecPayCreditTopUpResponse {
    /** @format uuid */
    transactionId?: string;
    payer?: string | null;
    status?: IoTecPayCollectionStatus;
    currency?: string | null;
    /** @format double */
    amount?: number;
    statusCode?: string | null;
    statusMessage?: string | null;
    /** @format double */
    totalTransactionCharge?: number | null;
}

export interface NiraPasswordRequest {
    /** @minLength 1 */
    newPassword: string;
}

export interface NotFoundResult {
    /** @format int32 */
    statusCode?: number;
}

export interface OkResult {
    /** @format int32 */
    statusCode?: number;
}

export interface OnboardingActivityFormFieldViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    name: string | null;
    label: string | null;
    fieldType?: OnboardingActivityFieldType;
    helperText?: string | null;
    placeholderText?: string | null;
    isRequired?: boolean;
    shouldVerify?: boolean;
    options?: string[] | null;
    defaultValue?: string | null;
    /** @format double */
    minValue?: number | null;
    /** @format double */
    maxValue?: number | null;
    /** @format int32 */
    displayOrder?: number;
    verifyWithOtp?: boolean | null;
}

export interface OnboardingTemplateActivityViewModel {
    /** @format uuid */
    id?: string;
    name: OnboardingActivity;
    label: string | null;
    helperText?: string | null;
    helperImageUrl?: string | null;
    group?: string | null;
    /** @format int32 */
    displayOrder?: number;
    shouldVerify?: boolean;
    fieldsToVerify?: string[] | null;
    verificationType?: OnboardingVerificationType;
    activityType?: OnboardingActivityType;
    /** @format uuid */
    documentId?: string | null;
    allowedTypes?: string[] | null;
    captureAction?: OnboardingActivityCaptureAction;
    /** @format int32 */
    maxSizeInBytes?: number | null;
    fields?: OnboardingActivityFormFieldViewModel[] | null;
    formData?: Record<string, any>;
    documentData?: Record<string, any>;
    ocrData?: Record<string, any>;
    faceVerificationData?: Record<string, any>;
}

/**
 * Represents the data model used to create a new onboarding template.
 * This includes configuration for what user information should be captured, required, or verified during onboarding.
 */
export interface OnboardingTemplateCreateModel {
    /** The name of the onboarding template. */
    name: string | null;
    /** A short description of what the template is for. */
    description: string | null;
    /** The subject of the invitation email. */
    invitationEmailSubject?: string | null;
    /** The body content of the invitation email. */
    invitationEmailBody?: string | null;
    /** The subject of the completion email. */
    completionEmailSubject?: string | null;
    /** The body content of the completion email. */
    completionEmailBody?: string | null;
    /** SMS content to be sent with the invitation. */
    invitationSms?: string | null;
    /** SMS content to be sent after onboarding completion. */
    completionSms?: string | null;
    /** Whether to capture a national ID. */
    captureNationalId?: boolean;
    /** Whether to verify the provided national ID. */
    verifyNationalId?: boolean;
    /** Whether the national ID is required. */
    requireNationalId?: boolean;
    /** Whether to capture a facial image. */
    captureFace?: boolean;
    /** Whether to verify the facial image. */
    verifyFace?: boolean;
    /** Whether facial data is required. */
    requireFace?: boolean;
    /** Whether to capture a phone number. */
    capturePhoneNumber?: boolean;
    /** Whether to verify the phone number. */
    verifyPhoneNumber?: boolean;
    /** Whether a phone number is required. */
    requirePhoneNumber?: boolean;
    /** Whether to capture an email address. */
    captureEmailAddress?: boolean;
    /** Whether to verify the email address. */
    verifyEmailAddress?: boolean;
    /** Whether an email address is required. */
    requireEmailAddress?: boolean;
    /** Whether to capture a physical address. */
    capturePhysicalAddress?: boolean;
    /** Whether to verify the physical address. */
    verifyPhysicalAddress?: boolean;
    /** Whether a physical address is required. */
    requirePhysicalAddress?: boolean;
    /** Whether to capture a mobile money number. */
    captureMobileMoneyNumber?: boolean;
    /** Whether to verify the mobile money number. */
    verifyMobileMoneyNumber?: boolean;
    /** Whether a mobile money number is required. */
    requireMobileMoneyNumber?: boolean;
    /** Whether to capture a bank account. */
    captureBankAccount?: boolean;
    /** Whether to verify the bank account. */
    verifyBankAccount?: boolean;
    /** Whether a bank account is required. */
    requireBankAccount?: boolean;
}

export interface OnboardingTemplateEditModel {
    /** @format uuid */
    id?: string;
    /** The name of the onboarding template. */
    name: string | null;
    /** A short description of what the template is for. */
    description: string | null;
    /** The subject of the invitation email. */
    invitationEmailSubject?: string | null;
    /** The body content of the invitation email. */
    invitationEmailBody?: string | null;
    /** The subject of the completion email. */
    completionEmailSubject?: string | null;
    /** The body content of the completion email. */
    completionEmailBody?: string | null;
    /** SMS content to be sent with the invitation. */
    invitationSms?: string | null;
    /** SMS content to be sent after onboarding completion. */
    completionSms?: string | null;
    /** Whether to capture a national ID. */
    captureNationalId?: boolean;
    /** Whether to verify the provided national ID. */
    verifyNationalId?: boolean;
    /** Whether the national ID is required. */
    requireNationalId?: boolean;
    /** Whether to capture a facial image. */
    captureFace?: boolean;
    /** Whether to verify the facial image. */
    verifyFace?: boolean;
    /** Whether facial data is required. */
    requireFace?: boolean;
    /** Whether to capture a phone number. */
    capturePhoneNumber?: boolean;
    /** Whether to verify the phone number. */
    verifyPhoneNumber?: boolean;
    /** Whether a phone number is required. */
    requirePhoneNumber?: boolean;
    /** Whether to capture an email address. */
    captureEmailAddress?: boolean;
    /** Whether to verify the email address. */
    verifyEmailAddress?: boolean;
    /** Whether an email address is required. */
    requireEmailAddress?: boolean;
    /** Whether to capture a physical address. */
    capturePhysicalAddress?: boolean;
    /** Whether to verify the physical address. */
    verifyPhysicalAddress?: boolean;
    /** Whether a physical address is required. */
    requirePhysicalAddress?: boolean;
    /** Whether to capture a mobile money number. */
    captureMobileMoneyNumber?: boolean;
    /** Whether to verify the mobile money number. */
    verifyMobileMoneyNumber?: boolean;
    /** Whether a mobile money number is required. */
    requireMobileMoneyNumber?: boolean;
    /** Whether to capture a bank account. */
    captureBankAccount?: boolean;
    /** Whether to verify the bank account. */
    verifyBankAccount?: boolean;
    /** Whether a bank account is required. */
    requireBankAccount?: boolean;
}

export interface OnboardingTemplateViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    name: string | null;
    description: string | null;
    invitationEmailSubject?: string | null;
    invitationEmailBody?: string | null;
    completionEmailSubject?: string | null;
    completionEmailBody?: string | null;
    invitationSms?: string | null;
    completionSms?: string | null;
    /** @format int32 */
    expiryInMinutes?: number | null;
    createdByData?: ComboModel;
    templateType?: OnboardingTemplateType;
    /** @format int32 */
    version?: number;
    /** @format double */
    minimumTemplateCharge?: number;
    /** @format double */
    maximumTemplateCharge?: number;
    isActive?: boolean;
    /** @format date-time */
    lastUpdated?: string | null;
    verificationType?: OnboardingVerificationType;
    /** @format double */
    totalTemplateCharge?: number;
    activities?: OnboardingTemplateActivityViewModel[] | null;
}

export interface OnboardingWorkflowActivityViewModel {
    /** @format uuid */
    id?: string;
    name: OnboardingActivity;
    label: string | null;
    helperText?: string | null;
    helperImageUrl?: string | null;
    group?: string | null;
    /** @format int32 */
    displayOrder?: number;
    shouldVerify?: boolean;
    fieldsToVerify?: string[] | null;
    verificationType?: OnboardingVerificationType;
    status: OnboardingActivityStatus;
    activityType?: OnboardingActivityType;
    /** @format uuid */
    documentId?: string | null;
    allowedTypes?: string[] | null;
    captureAction?: OnboardingActivityCaptureAction;
    /** @format int32 */
    maxSizeInBytes?: number | null;
    fields?: OnboardingActivityFormFieldViewModel[] | null;
    formData?: Record<string, any>;
    documentData?: Record<string, any>;
    ocrData?: Record<string, any>;
    faceVerificationData?: Record<string, any>;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    lastUpdated?: string | null;
    isDeleted?: boolean;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    errorCode?: string | null;
    errorMessage?: string | null;
    /** DataValidationResultJson */
    dataValidationResultJson?: string | null;
}

export interface OnboardingWorkflowCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    narration: string | null;
    /** @format uuid */
    templateId?: string;
    scheme?: string | null;
    host?: string | null;
}

export interface OnboardingWorkflowCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: OnboardingWorkflowCreateModel[] | null;
}

export interface OnboardingWorkflowViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    /** @format uuid */
    templateId?: string;
    template?: ComboModel;
    link?: string | null;
    externalId?: string | null;
    externalLink?: string | null;
    onboardingId?: string | null;
    fullName?: string | null;
    /**
     * Optional expiration time for the onboarding request.
     * If null, the request does not expire.
     * @format date-time
     */
    expiryTime?: string | null;
    /**
     * The time when the onboarding sms was sent to the customer.
     * @format date-time
     */
    smsSentAt?: string | null;
    /**
     * The time when the onboarding email was sent to the customer.
     * @format date-time
     */
    emailSentAt?: string | null;
    /**
     * Time when the person clicked the link
     * @format date-time
     */
    respondedOn?: string | null;
    phoneNumber?: string | null;
    narration?: string | null;
    email?: string | null;
    workflowActivities?: OnboardingWorkflowActivityViewModel[] | null;
    metaData?: Record<string, string>;
}

export interface OnboardingWorkflowViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: OnboardingWorkflowViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface FaceMatchViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: FaceMatchViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface PartnerCallbackCreateModel {
    category?: ProductCategory;
    httpVerb?: HttpVerb;
    /** @minLength 1 */
    endpointUrl: string;
    /** @format uuid */
    partnerId?: string;
    credentials?: PartnerCallbackCredential[] | null;
}

export interface PartnerCallbackCredential {
    header?: string | null;
    value?: string | null;
}

export interface PartnerCallbackCredentialViewModel {
    header?: string | null;
}

export interface PartnerCallbackUpdateModel {
    /** @format uuid */
    id?: string;
    category?: ProductCategory;
    httpVerb?: HttpVerb;
    /** @minLength 1 */
    endpointUrl: string;
    credentials?: PartnerCallbackCredential[] | null;
}

export interface PartnerCallbackViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: ProductCategory;
    httpVerb?: HttpVerb;
    endpointUrl?: string | null;
    credentials?: PartnerCallbackCredentialViewModel[] | null;
    /** @format uuid */
    partnerId?: string;
    createdByData?: ComboModel;
}

export interface PartnerConfigurationEditModel {
    /** @format uuid */
    partnerId?: string;
    useNiraNamePermutations?: boolean;
}

export interface PartnerConfigurationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @maxLength 50 */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    useNiraNamePermutations?: boolean;
}

export interface PartnerConsentRequestCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    metaData?: Record<string, string>;
    /**
     * The template that is being used to request for consent.
     * @format uuid
     */
    templateId?: string;
    /**
     * @format tel
     * @minLength 1
     */
    phoneNumber: string;
    /** @format email */
    email?: string | null;
    /**
     * Identifier for the entity who owns the data.
     * @minLength 1
     * @maxLength 150
     */
    dataIdentifier: string;
    /** @format uuid */
    partnerId?: string;
}

export interface PartnerCreateModel {
    /** @format uuid */
    id: string;
    partnerIps: string[];
}

export interface PartnerIpViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @minLength 1 */
    ipAddress: string;
}

export interface PartnerMemberViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    partner?: ComboModel;
    person?: ContactMiniViewModel;
    /** @format uuid */
    partnerId?: string;
    active?: boolean;
    roles?: string[] | null;
}

export interface PartnerUpdateModel {
    /** @format uuid */
    id?: string;
    active?: boolean;
    company?: CompanyInfo;
    partnerIps: string[];
}

export interface PartnerViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    clientId?: string | null;
    name?: string | null;
    active?: boolean;
    company?: XContactModel;
    members?: PartnerMemberViewModel[] | null;
    partnerIps?: PartnerIpViewModel[] | null;
    apiKey?: ApiKeyViewModel;
    products?: ProductViewModel[] | null;
}

export interface PersonCreateModel {
    /** @minLength 1 */
    surname: string;
    /** @minLength 1 */
    givenNames: string;
    nationality?: string | null;
    gender?: CustomerGender;
    /** @format date */
    dateOfBirth?: string | null;
    civilStatus?: CustomerCivilStatus;
    salutation?: CustomerSalutation;
    /** @format email */
    email?: string | null;
    /** @format tel */
    phone?: string | null;
    /** @format tel */
    secondaryPhone?: string | null;
    tinNumber?: string | null;
    idCategory?: CustomerIdentificationCategory;
    idNumber?: string | null;
    idDocumentNumber?: string | null;
    /** @format date-time */
    idIssueDate?: string | null;
    /** @format date-time */
    idExpiryDate?: string | null;
    /** @format uuid */
    partnerId?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    profession?: string | null;
    externalId?: string | null;
    tags?: string | null;
    forceCreation?: boolean;
}

export interface PersonCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: PersonCreateModel[] | null;
}

export interface PersonCustomerViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    customerId?: string;
    salutation?: CustomerSalutation;
    surname?: string | null;
    givenNames?: string | null;
    nationality?: string | null;
    fullName?: string | null;
    gender?: CustomerGender;
    civilStatus?: CustomerCivilStatus;
    /** @format date */
    dateOfBirth?: string | null;
    profession?: string | null;
}

export interface PhoneNumberVerificationCreateModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    /**
     * Customer's Phone number
     * @minLength 1
     */
    phoneNumber: string;
}

export interface PhoneNumberVerificationCreateModelBulkVerificationPreviewResponse {
    /** @format uuid */
    docId?: string;
    document?: DocViewModel;
    /** @format int32 */
    totalRecords?: number;
    errors?: ImportError[] | null;
    sample?: PhoneNumberVerificationCreateModel[] | null;
}

export interface PhoneNumberVerificationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    phoneNumber?: string | null;
    registeredName?: string | null;
    network?: string | null;
    verificationStatus?: PhoneNumberVerificationStatus;
}

export interface PhoneNumberVerificationViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: PhoneNumberVerificationViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ProductCreateModel {
    category?: ProductCategory;
    /** @format uuid */
    partnerId?: string;
}

export interface ProductCreditsIoTecPayTopUpModel {
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format double */
    credits?: number;
    /** @format double */
    amountToPay?: number;
    /** @minLength 1 */
    memo: string;
    /**
     * @format tel
     * @minLength 1
     */
    mobileMoneyNumber: string;
}

export interface ProductCreditsManualTopUpModel {
    /** @format uuid */
    partnerId?: string;
    productCategory: ProductCategory;
    /**
     * @format double
     * @min 1
     */
    credits?: number;
    /** @minLength 1 */
    memo: string;
}

export interface ProductCreditsWalletToWalletTopUpModel {
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format double */
    credits?: number;
    /** @format double */
    amountToPay?: number;
    /** @minLength 1 */
    memo: string;
    /** @minLength 1 */
    walletCode: string;
    walletPin: string | null;
}

export interface ProductPriceBand {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    /** @format date-time */
    lastUpdated?: string | null;
    isDeleted?: boolean;
    category?: ProductCategory;
    /** @maxLength 35 */
    name?: string | null;
    /** @format int32 */
    lowerLimit?: number;
    /** @format int32 */
    upperLimit?: number | null;
    /** @format double */
    unitPrice?: number;
    /** @maxLength 3 */
    currency?: string | null;
    /** @maxLength 50 */
    createdBy?: string | null;
}

export interface ProductPriceBandCreateModel {
    category?: ProductCategory;
    /** @maxLength 35 */
    name?: string | null;
    /** @format int32 */
    lowerLimit?: number;
    /** @format int32 */
    upperLimit?: number | null;
    /** @format double */
    unitPrice?: number;
}

export interface ProductPriceBandUpdateModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @maxLength 35 */
    name?: string | null;
    /** @format int32 */
    lowerLimit?: number;
    /** @format int32 */
    upperLimit?: number | null;
    /** @format double */
    unitPrice?: number;
}

export interface ProductPriceBandViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    name?: string | null;
    /** @format int32 */
    lowerLimit?: number;
    /** @format int32 */
    upperLimit?: number | null;
    /** @format double */
    unitPrice?: number;
    /** @format double */
    purchasableCredits?: number;
    /** @format double */
    purchasableAmount?: number;
    category?: ProductCategory;
    currency?: string | null;
}

export interface ProductPurchaseOrderInvoiceViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format uuid */
    purchaseOrderId?: string;
    invoiceNumber: string | null;
    status?: ProductPurchaseOrderInvoiceStatus;
    /** @format date-time */
    dueDate?: string | null;
    memo: string | null;
    partnerAddress?: string | null;
    partnerEmail: string | null;
    partnerPhone: string | null;
    partnerName: string | null;
    /** @format double */
    amount?: number;
    /** @format double */
    taxAmount?: number;
    /** @format double */
    credits?: number;
    /** @format double */
    unitPrice?: number;
    /** @format uuid */
    updatedBy?: string | null;
}

export interface ProductPurchaseOrderIoTecPayViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category: string | null;
    currency: string | null;
    walletId: string | null;
    externalId: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    payer: string | null;
    payerNote: string | null;
    /** @format double */
    amount?: number;
    payeeNote: string | null;
    channel?: string | null;
    transactionChargesCategory: string | null;
    productCategory?: ProductCategory;
    status?: IoTecPayCollectionStatus;
    /** @format double */
    credits?: number;
    /** @format double */
    totalAmountPaid?: number;
    /** @format double */
    transactionCharge?: number;
    /** @format double */
    vendorCharge?: number;
    /** @format double */
    totalTransactionCharge?: number;
    payerName?: string | null;
    /** @format uuid */
    purchaseOrderId?: string;
}

export interface ProductPurchaseOrderPreviewRequestModel {
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format double */
    credits?: number;
    paymentMethod?: ProductPaymentMethod;
    /** Added for mobile money payment method. */
    mobileMoneyNumber?: string | null;
    /** Added for iotec wallet payment method */
    walletCode?: string | null;
    /** Added for iotec wallet payment method */
    walletPin?: string | null;
}

export interface ProductPurchaseOrderPreviewResponseModel {
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format double */
    credits?: number;
    paymentMethod?: ProductPaymentMethod;
    /** @format double */
    amount?: number;
    /** @format double */
    transactionCharges?: number;
    /** Added for mobile money payment method. */
    mobileMoneyNumber?: string | null;
    /** Added for wallet code payment method. */
    walletCode?: string | null;
    /** Added for wallet code payment method. */
    walletPin?: string | null;
}

export interface ProductPurchaseOrderViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    productCategory?: ProductCategory;
    paymentMethod?: ProductPaymentMethod;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format uuid */
    requestId?: string;
    memo: string | null;
    /** @format double */
    amount?: number;
    /** @format double */
    credits?: number;
    /** @format uuid */
    purchaseOrderDetailId?: string;
    invoiceDetail?: ProductPurchaseOrderInvoiceViewModel;
    ioTecPayDetail?: ProductPurchaseOrderIoTecPayViewModel;
    /** @format uuid */
    priceBandId?: string;
    priceBand?: ProductPriceBand;
}

export interface ProductPurchaseOrderViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: ProductPurchaseOrderViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface ProductSubscriptionCreateModel {
    category?: ProductCategory;
    /** @format uuid */
    partnerId?: string;
}

export interface ProductSubscriptionViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: ProductCategory;
    /** @format double */
    creditsBalance?: number;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format uuid */
    priceBandId?: string;
    priceBand?: ComboModel;
}

export interface ProductTopUpInvoiceCreateModel {
    /** @format uuid */
    partnerId?: string;
    productCategory?: ProductCategory;
    /** @format uuid */
    requestId?: string;
    /** @format date-time */
    dueDate?: string;
    memo: string | null;
    /** @format double */
    amount?: number;
    /** @format double */
    taxAmount?: number;
    /** @format double */
    credits: number;
}

export interface ProductTopUpInvoicePayModel {
    /** @format uuid */
    invoiceId?: string;
    /** @format uuid */
    partnerId?: string;
    memo: string | null;
}

export interface ProductTopUpModel {
    /** @format uuid */
    id?: string;
    /**
     * @format int64
     * @min 1
     */
    credits?: number;
    /** @minLength 1 */
    reference: string;
}

export interface ProductViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    category?: ProductCategory;
    /** @format uuid */
    partnerId?: string;
    /** @format int64 */
    balance?: number;
    /** @format date-time */
    lastUpdated?: string | null;
    description?: string | null;
}

export interface Shareholder {
    currency?: string | null;
    givenName?: string | null;
    legalName?: string | null;
    middleName?: string | null;
    numberOfShares?: string | null;
    shareholding?: string | null;
    surname?: string | null;
    type?: string | null;
}

export interface Shares {
    numberOfOrdinaryShares?: string | null;
    numberOfPreferentialShares?: string | null;
    numberOfShares?: string | null;
    numberOfUnallotedShares?: string | null;
    shareCapital?: string | null;
    sharePrice?: string | null;
}

export interface SystemRole {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    roleCategory?: RoleCategory;
    roleSubCategory?: RoleSubCategory;
    requiresPrimaryUser?: boolean;
}

export interface TemplateDocCreateModel {
    /** @format uuid */
    templateId?: string;
    /** @format uuid */
    documentId?: string;
}

export interface TinNumberVerificationRequestModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    /**
     * Customer's TIN number
     * @minLength 1
     */
    tin: string;
}

export interface TinNumberVerificationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    tinNumber?: string | null;
    taxPayerName?: string | null;
    registrationStatus?: string | null;
    verificationStatus?: string | null;
    responsePayload?: UraGetClientRegistrationResult;
}

export interface TinNumberVerificationViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: TinNumberVerificationViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface UnauthorizedResult {
    /** @format int32 */
    statusCode?: number;
}

export interface UraGetClientRegistrationResult {
    contactNumber?: string | null;
    county?: string | null;
    district?: string | null;
    errorCode?: string | null;
    errorDesc?: string | null;
    isCustomsAgent?: string | null;
    isLicenseValid?: string | null;
    licenseNumber?: string | null;
    mobileNumber?: string | null;
    postalAddress?: string | null;
    registrationStatus?: string | null;
    subCounty?: string | null;
    tin?: string | null;
    taxPayerEmail?: string | null;
    taxPayerName?: string | null;
    telephoneNumber?: string | null;
    typeofUser?: string | null;
    village?: string | null;
}

export interface UrsbEntityFullResponseData {
    address?: Address;
    businessRegistrationNumber?: string | null;
    directors?: Director[] | null;
    dissolutionDate?: string | null;
    entityName?: string | null;
    incorporatedIn?: string | null;
    incorporationDate?: string | null;
    natureOfBusiness?: string | null;
    /** @format int64 */
    numberOfDirectors?: number | null;
    /** @format int64 */
    numberOfShareholders?: number | null;
    /** @format int64 */
    numberOfSubscribers?: number | null;
    officialEmail?: string | null;
    officialTelephoneNumber?: string | null;
    registrationDate?: string | null;
    registrationStatus?: string | null;
    secretary?: Director[] | null;
    shareCapital?: string | null;
    shareholders?: Shareholder[] | null;
    shares?: Shares;
    subType?: string | null;
    subscribers?: Director[] | null;
    type?: string | null;
}

export interface UserViewModel {
    subject?: string | null;
    /** @format uuid */
    contactId?: string | null;
    roles?: string[] | null;
    name?: string | null;
    email?: string | null;
    clientId?: string | null;
    authMode?: AuthMode;
    /** @format uuid */
    partnerId?: string;
    authority?: string | null;
    identityProvider?: string | null;
    /** @format date-time */
    loginTime?: string | null;
    emailVerified?: boolean;
    isClientCredentials?: boolean;
}

export interface VerifyPersonInformationRequestModel {
    referenceId?: string | null;
    name?: string | null;
    /** @format uuid */
    bulkId?: string | null;
    /** Determine if we should execute this call in the background */
    isBlocking?: boolean;
    /**
     * The customer for who this request is being made against
     * @format uuid
     */
    customerId?: string | null;
    nationalId?: string | null;
    documentId?: string | null;
    dateOfBirth?: string | null;
    surname?: string | null;
    givenNames?: string | null;
}

export interface VerifyPersonInformationViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /** @format uuid */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    /** @format uuid */
    bulkId?: string | null;
    /** @format uuid */
    customerId?: string | null;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /** @format int32 */
    attemptCount?: number;
    channel?: string | null;
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    referenceId?: string | null;
    errorCode?: string | null;
    errorMessage?: string | null;
    nationalId?: string | null;
    documentId?: string | null;
    dateOfBirth?: string | null;
    surname?: string | null;
    givenNames?: string | null;
    otherNames?: string | null;
    /** @format uuid */
    multiRequestId?: string;
    /** @format int32 */
    permutation?: number;
    matchingStatus?: string | null;
    cardStatus?: string | null;
    transactionStatus?: string | null;
    captureMethod?: CaptureMethod;
    dateOfExpiration?: string | null;
    gender?: string | null;
    document?: {
        "name": string | null;
        "contentType": string | null;
        "originalName": string | null;
        "description": string | null;
        "size": string | null;
        "partnerId": string | null;
        "id": string | null;
        "createdAt": string | null;
        "createdBy": string | null;
    },
}

export interface VerifyPersonInformationViewModelPaginatedListViewModel {
    /** @format int32 */
    page?: number;
    /** @format int32 */
    totalPages?: number;
    /** @format int32 */
    total?: number;
    data?: VerifyPersonInformationViewModel[] | null;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface XContactModel {
    id?: string | null;
    name?: string | null;
    email?: string | null;
    phone?: string | null;
}


export enum FaceMatchStatus {
    Pending = "Pending",
    Processing = "Processing",
    Success = "Success",
    Failed = "Failed",
}

/**
 * Represents the response of a face matching request, including references to uploaded images,
 * the verification result, and any status or diagnostic information.
 */
export interface FaceMatchViewModel {
    /** @format uuid */
    id?: string;
    /** @format date-time */
    createdAt?: string;
    createdBy?: string | null;
    /**
     * The unique identifier of the partner account making this request.
     * @format uuid
     * @example "5e83b187-801e-410e-b76e-f491928547e0"
     */
    partnerId?: string;
    partner?: ComboModel;
    /** @format date-time */
    sentAt?: string | null;
    /** @format uuid */
    productId?: string;
    status?: RequestStatus;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int64 */
    runningBalance?: number;
    /** @format date-time */
    processedAt?: string | null;
    /**
     * Total number of times this request has been attempted.
     * @format int32
     */
    attemptCount?: number;

    /**  
    * Request Number to identify this request.
    * @format int32
    */
    requestNumber?: string | null;
    /**
     * The channel through which the request was made.
     * @example "ApiKey"
     */
    requestName?: string | null;
    /**
     * Request name
     * @example "John Doe"
     */
    channel?: string | null;
    /** Identifier of the entity that initiated this request. */
    requestedBy?: string | null;
    requestedByData?: ComboModel;
    /**
     * A reference to the request used by your external system for reconciliation purposes.
     * @example "001"
     */
    referenceId?: string | null;
    /** Error code returned when the request fails. */
    errorCode?: string | null;
    /** Detailed error message explaining what went wrong when the request fails. */
    errorMessage?: string | null;
    /**
     * This is the unique identifier of the first facial image (`photo1`) that was uploaded
     * when performing the face match request
     * @format uuid
     * @example "f47ac10b-58cc-4372-a567-0e02b2c3d479"
     */
    image1Id?: string;
    /**
     * Represents a document (such as an uploaded image, PDF, or other file)
     * stored and linked to a verification process.
     */
    image1?: DocViewModel;
    /**
     * This is the unique identifier of the second facial image (`photo2`) that was uploaded
     * when performing the face match request
     * @format uuid
     * @example "9c6f4c7b-1b1e-4cf6-8b2d-2e66a9b63c77"
     */
    image2Id?: string;
    /**
     * Represents a document (such as an uploaded image, PDF, or other file)
     * stored and linked to a verification process.
     */
    image2?: DocViewModel;
    faceMatchStatus?: FaceMatchStatus;
    /**
     * Confidence score returned by the face recognition service (0.0–1.0).
     * @format double
     * @example 0.873
     */
    confidence?: number;
    /**
     * Indicates whether the two faces are considered identical.
     * @example true
     */
    isIdentical?: boolean;
    /** Raw JSON response from the external face recognition service, useful for troubleshooting. */
    rawResponseData?: string | null;
}

/**
 * Represents the parsed OCR response from a national ID document,
 * containing personal details extracted from the image and
 * the status of the OCR processing request.
 */
export interface OcrResponseModel {
    success: boolean;
    message: string;
    surname: string;
    requestId: string;
    givenName: string;
    nationalId: string;
    documentId: string;
    dateOfBirth: string;
    dateOfExpiration: string;
    gender: string;
}

